module.exports = __webpack_public_path__ + "edit-preset.a422339dd7c7aaa1e67a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/edit-preset.svg
// module id = ./src/assets/img/edit-preset.svg
// module chunks = main